module.exports = __webpack_public_path__ + "img/52.f4d47a77.jpg";